import styled from "styled-components";

import { colors, radii } from "shared/ui/tokens";

export const Group = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const Option = styled.label<{ $active?: boolean; $disabled?: boolean }>`
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 12px 14px;
    border: 1px solid ${({ $active }) => ($active ? colors.primary : colors.fieldBorder)};
    border-radius: ${radii.base};
    background: ${colors.surface};
    cursor: ${({ $disabled }) => ($disabled ? "default" : "pointer")};
    opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};
`;

export const Radio = styled.input`
    margin: 2px 0 0;
    accent-color: ${colors.primary};
`;

export const OptionText = styled.div`
    flex: 1 1 auto;
    min-width: 0;
`;

export const OptionLabel = styled.span`
    display: block;
    font-size: 0.9375rem;
    color: ${colors.textPrimary};
`;

export const OptionDescription = styled.span`
    display: block;
    margin-top: 2px;
    font-size: 12px;
    color: ${colors.textSecondary};
`;
